var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Bitmovin8 = youbora.Adapter.extend({

  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.getCurrentTime()
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    return this.player.getPlaybackSpeed()
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    return this.player.getDroppedVideoFrames()
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.getDuration()
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    var videodata = this.player.getPlaybackVideoData()
    var videoquality = this.player.getVideoQuality()
    if (videodata && videodata.bitrate) {
      return videodata.bitrate
    } else if (videoquality && videoquality.bitrate) {
      return videoquality.bitrate
    }
    return null
  },

  /** Override to return rendition */
  getRendition: function () {
    var videodata = this.player.getPlaybackVideoData()
    var videoquality = this.player.getVideoQuality()
    if (videoquality && videoquality.bitrate) {
      return youbora.Util.buildRenditionString(videoquality.width, videoquality.height, videoquality.bitrate)
    }
    if (videodata && videodata.bitrate) {
      return youbora.Util.buildRenditionString(videodata.width, videodata.height, videodata.bitrate)
    }
    return null
  },

  /** Override to return title */
  getTitle: function () {
    return this.player.getSource().title
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this.player.isLive()
  },

  /** Override to return resource URL. */
  getResource: function () {
    try {
      if (this.player.getManifest()) {
        if (this.player.getManifest().indexOf('MPD') > 0) {
          return this.player.getSource().dash
        } else {
          return this.player.getSource().hls
        }
      }
    } catch (err) {
      return this.player.getSource().progressive || this.player.getSource().hls
    }
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return this.player.version
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Bitmovin"
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    var events = this.player.exports.PlayerEvent
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player)

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)

    // References
    this.references = []
    this.references[events.Play] = this.playListener.bind(this)
    this.references[events.Paused] = this.pauseListener.bind(this)
    this.references[events.Playing] = this.playingListener.bind(this)
    this.references[events.Error] = this.errorListener.bind(this)
    this.references[events.Seek] = this.seekingListener.bind(this)
    this.references[events.PlaybackFinished] = this.endedListener.bind(this)
    this.references[events.TimeChanged] = this.timeupdateListener.bind(this)

    // Register listeners
    for (var key in this.references) {
      this.player.on(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.off(key, this.references[key])
      }
      this.references = []
    }
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'timeupdate' event. */
  timeupdateListener: function (e) {
    if (this.getPlayhead() > 0.2) {
      this.fireStart()
      if (!this.flags.isJoined) {
        this.monitor.skipNextTick()
        this.fireJoin()
      }
    }
    if (!this.player.isPaused() && this.flags.isSeeking) {
      this.fireSeekEnd()
    }
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) {
    this.fireStart()
    this.fireResume()
    if (!this.flags.isJoined) {
      this.monitor.skipNextTick()
      this.fireJoin()
    }
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError(e.code, e.name)
    this.fireStop()
  },

  /** Listener for 'seeking' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  /** Listener for 'ended' event. */
  endedListener: function (e) {
    this.fireStop()
  }
}
)

module.exports = youbora.adapters.Bitmovin8
